import Controller from '@ember/controller';
import SetupGuide from 'cio/models/setup-guide';
import moment from 'moment-timezone';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import RouterService from '@ember/routing/router-service';

export default class SetupGuideWelcomeController extends Controller {
  declare model: SetupGuide;
  @service router!: RouterService;

  @action
  start() {
    this.model.set('startedAt', moment().unix());
    this.model.save();
    if (this.model.personalizationChangeStepsOrder) {
      this.router.transitionTo('setup-guide.sources');
    } else {
      this.router.transitionTo('setup-guide.create-campaign');
    }
  }
}
